import { render, staticRenderFns } from "./index_mp.vue?vue&type=template&id=4a2d867a&scoped=true&"
import script from "./index_mp.vue?vue&type=script&lang=js&"
export * from "./index_mp.vue?vue&type=script&lang=js&"
import style0 from "./index_mp.vue?vue&type=style&index=0&id=4a2d867a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d867a",
  null
  
)

export default component.exports